<template>
  <div class="content extraEquipmentDetail">
    <div class="basic">
      <div class="headline">
        <p class="title">
          {{title}}
        </p>
        <div class="info">
          <div class="left">
            <span class="name">创建人</span>
            <span style="user-select:none;cursor: pointer;" @click="showCard(user_id,$event)">{{username}}</span>
          </div>
          <div class="seprate"></div>
          <div class="right">
            <span class="name">状态</span>
            <span>{{statusname}}</span>
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="item">
          <span class="name">编号：</span>
          <div class="input">
            <input disabled type="text" v-model="name">
          </div>
        </div>
        <div class="item">
          <span class="name">类型：</span>
          <div class="input">
            <select disabled v-model="classInfo.id">
              <option :value="c.type_id" v-for="(c, i) in classes" :key="i">{{c.title}}</option>
            </select>
            <img src="@assets/img/resources/down.svg" alt="down" class="down">
          </div>
        </div>
        <div class="item">
          <span class="name">品牌：</span>
          <span class="input">
            <input :disabled="statusNum == 2 ? true : false" type="text" v-model="brand">
          </span>
        </div>
        <div class="item">
          <span class="name">型号：</span>
          <span class="input">
            <input :disabled="statusNum == 2 ? true : false" type="text" v-model="device_model">
          </span>
        </div>
        <div class="item">
          <span class="name">序列号：</span>
          <span class="input">
            <input :disabled="statusNum == 2 ? true : false" type="text" v-model="serial_num">
          </span>
        </div>
        <div class="item">
          <span class="name">采购日期：</span>
          <span class="input date">
            <el-date-picker
              :disabled="statusNum == 2"
              v-model="datePicker"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </span>
        </div>
        <div class="item">
          <span class="name">保管人：</span>
          <span class="input">
            <input type="text" :disabled="statusNum == 2 ? true : false" v-model="keeper">
          </span>
        </div>
        <div class="item">
          <span class="name">存放地：</span>
          <span class="input">
            <input type="text" :disabled="statusNum == 2 ? true : false" v-model="location">
          </span>
        </div>
        <div class="item">
          <!-- <span class="name">采购日期</span>
          <span class="input">
            <input type="text" v-model="seller">
          </span> -->
        </div>
      </div>
      <div class="textarea-container">
        <div class="remark">
          <span class="mark">
            其他附件
          </span>
          <textarea :disabled="statusNum == 2 ? true : false" maxlength="60" v-model="other_comment">
          </textarea>
          <span class="count">{{`${other_comment.length}/60`}}</span>
        </div>
        <div class="remark">
          <span class="mark">
            备注
          </span>
          <textarea :disabled="statusNum == 2 ? true : false" maxlength="60" v-model="remark">
          </textarea>
          <span class="count">{{`${remark.length}/60`}}</span>
        </div>
      </div>
    </div>
    <div class="about">
      <div class="toggler">
        <div :class="{toggle: true, on: toggleOn.id === t.id}" v-for="(t, i) in toggles" :key="i" @click="switchToggle(t)">
          {{t.title}}
        </div>
      </div>
      <div class="filter" v-if="toggleOn.id === toggles[0].id">
        <div class="l">
          <globalFilter ref="globalFilter1" />
          <date-picker v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm>
          </date-picker>
        </div>
        <div class="r">
          <img src="../../assets/img/resources/notice.png" alt="">
          <span>数据仅保留{{days}}天</span>
        </div>
      </div>
      <div class="filter" v-if="toggleOn.id === toggles[1].id">
        <div class="l">
          
        </div>
        <div class="r">
          <img src="../../assets/img/resources/notice.png" alt="">
          <span>数据仅保留{{days}}天</span>
        </div>
      </div>
      <div class="filter" v-if="toggleOn.id === toggles[2].id">
        <div class="l">
          
        </div>
        <div class="r">
          <img src="../../assets/img/resources/notice.png" alt="">
          <span>数据仅保留{{days}}天</span>
        </div>
      </div>
      <div class="filter" v-if="toggleOn.id === toggles[3].id">
        <div class="l">
          
        </div>
        <div class="r">
          <img src="../../assets/img/resources/notice.png" alt="">
          <span>数据仅保留{{days}}天</span>
        </div>
      </div>
      <div class="tasks" v-if="toggleOn.id === toggles[0].id">
        <div class="titleline">
          <!-- <span class="tag">使用类</span> -->
          <span class="title">使用主题</span>
          <span class="status">状态</span>
          <span class="user">使用人</span>
          <span class="endTime">可使用时间</span>
          <span class="exportTime">归还确认时间</span>
          <!-- <span class="releaseTime">手动取消／结束时间</span> -->
          <span class="handle">操作</span>
        </div>
        <empty :msg="'暂无相关任务'" v-if="tasks.length === 0" />
        <div class="content" v-for="(l, i) in tasks" :key="i">
          <div class="item">
            <span class="theme">
              <p class="words">
                {{l.task_title}}
              </p>
            </span>
            <span class="status">{{l.status_name}}</span>
            <span  @click="showCard(l.user_id,$event)" class="user">
              <!-- {{l.persons.map(i => i.person_idstring).join(',')}} -->
              {{l.username}}
            </span>
            <span class="endTime">
              <span>{{l.start}}</span>
              <span>{{l.end}}</span>
            </span>
            <span class="exportTime">{{l.return_time}}</span>
            <!-- <span class="releaseTime">{{l.finish_time}}</span> -->
            <span :class="{handle: true}">
              <!-- <span v-if="l.status == 1" class="btn" @click="cancelTask(l.task_id)">
                取消
              </span>
              <span v-if="l.status == 2" class="btn" @click="endTask(l.task_id)">
                结束
              </span> -->
              <span @click="$ResourcesDetail(l.task_id)" class="btn">查看</span>
            </span>
          </div>
        </div>
      </div>
      <div class="records" v-if="toggleOn.id === toggles[1].id">
        <div class="titleline">
          <span class="title">出返库</span>
          <span class="time">操作时间</span>
          <span class="locate">外出地点</span>
          <span class="reporter">使用人信息</span>
          <!-- <span class="tel">联系电话</span> -->
          <span class="task">相关使用</span>
          <span class="handler">操作人</span>
          <span class="check1">设备检查</span>
        </div>
        <empty :msg="'暂无出返记录'" v-if="records.length === 0" />
        <div class="content" v-for="(l, i) in records" :key="i">
          <div class="item">
            <span class="title1">
              <span class="mark">
                {{l.log_status_name}}
              </span>
            </span>
            <span class="time">{{l.opt_time}}</span>
            <span class="locate" :title="l.address">{{l.address}}</span>
            <span class="reporter">
              <span v-for="(r, i) in l.users" :key="i">
                {{r}}
              </span>
            </span>
            <!-- <span class="tel">{{l.users}}</span> -->
            <span @click="toInterviewDetail(l.iview_id)" class="task" :title="l.title">{{l.title}}</span>
            <span class="handler">{{l.opt_username}}</span>
            <span class="check1">{{l.remark}}</span>
          </div>
        </div>
      </div>
      <div class="records" v-if="toggleOn.id === toggles[2].id">
        <div class="titleline">
          <span class="errtime">报障时间</span>
          <span class="errhandler1">操作人</span>
          <span class="check">故障描述</span>
        </div>
        <empty :msg="'暂无故障记录'" v-if="errList.length === 0" />
        <div class="content" v-for="(l, i) in errList" :key="i">
          <div class="item">
            <span class="errtime">{{l.raw_add_time}}</span>
            <span class="errhandler1">{{l.username}}</span>
            <span :title="l.remark" class="check">{{l.remark}}</span>
          </div>
        </div>
      </div>
      <div class="records" v-if="toggleOn.id === toggles[3].id">
        <div class="titleline">
          <span class="stitle">停启</span>
          <span class="time">操作时间</span>
          <span class="shandler">操作人</span>
          <span class="check">备注</span>
        </div>
        <empty :msg="'暂无启停记录'" v-if="startLog.length === 0" />
        <div class="content" v-for="(item, i) in startLog" :key="i">
          <div class="item">
            <span class="stitle">{{item.opt_type}}</span>
            <span class="time">{{item.raw_add_time}}</span>
            <span class="shandler">{{item.truename}}</span>
            <span class="check">{{item.remark}}</span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
    <div class="footline" :style="{width: `calc(100vw - ${footLineGap}px)`}">
      <div v-if="statusNum == 0" class="center">
        <div class="btn left" @click="delDevice()">删除设备</div>
        <div class="btn" @click="startUse()">启用设备</div>
      </div>
      <div v-else class="center">
        <div v-if="statusNum != 2" class="btn" @click="stopUse()">停用设备</div>
      </div>
      <div class="btn" v-if="statusNum != 2" @click="saveDevice()">保存设备</div>
      <div class="row">
        <div class="btn" @click="addError">添加故障</div>
        <div class="btn greenBtn" @click="exportRecords()">导出出返库记录</div>
      </div>
    </div>
    <stopUse ref="stopUse" />
  </div>
</template>

<script>
import pages from '@components/pages'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
import stopUse from '@components/stopUse'
import globalFilter from "@components/globalFilter";
import DatePicker from 'vue2-datepicker'

export default {
  name: 'equipmentDetail',
  components: {
    pages, empty, stopUse, DatePicker, globalFilter
  },
  computed: {
    baseId() {
      return this.baseInfo.id
    }
  },
  watch: {
    baseId(n) {
      this.changeClasses(n)
    },
    datePicker: {
      deep: true,
      handler: function (n) {
          // this.page.pageIndex = 1;

          this.start = common.stampToTime(n[0]);
          this.end = common.stampToTime(n[1]);
          let time = {
              start: this.start,
              end: this.end
          }
          this.getFilters(time)
          // this.changeTime();
      }
    }
  },
  data() {
    return {
      startLog: [],
      days: 0,
      datePicker: null,
      date: null,
      page: {
        page_count: 10,
        pageIndex: 1,
        pageSize: 10
      },
      username: '',
      statusNum: 1,
      statusname: '',
      title: '',
      remark: '',
      name: '',
      brand: '',
      device_model: '',
      serial_num: '',
      keeper: '',
      location: '',
      other_comment: '',
      locate: '',
      price: '',
      seller: '',
      bases: [],
      classes: [],
      gps: {
        name: '',
        locate: '',
        point: '',
        time: ''
      },
      baseInfo: {
        id: '',
        title: ''
      },
      classInfo: {
        id: '',
        title: ''
      },
      toggles: [
        {
          title: '使用情况',
          id: 1
        },
        {
          title: '出返记录',
          id: 2
        },
        {
          title: '故障记录',
          id: 3
        },
        {
          title: '停启记录',
          id: 4
        }
      ],
      toggleOn: {},
      tasks: [],
      records: [],
      footLineGap: 230,
      filterOptions: {
        start: '',
        end: ''
      },
      errList: [],
      user_id: ''
    }
  },
  methods: {
    toInterviewDetail(id) {
      if(id == 0) return
      common.jump('/interviewDetail?r='+id,true)
    },
    showCard(id, e) {
      if (id == 0) return;

      const el = e.target;

      this.$card(id, el);
    },
    addError() {
      this.$Dialog({
        title: '添加故障',
        maxLength: 60,
        placeholder: '请填写故障信息',
        canEdit: true,
        singleBtn: true,
        errTitle: '故障信息不能为空'
      }).then(res => {
        if(res){
          let info = {
            device_id: this.$route.query.d,
            remark: res
          }

          common.myFetch(apis.Add_bug, info)
          .then((data) => {
            this.$toast(data)
            this.page.pageIndex = 1
            this.getList()
          })
        }
      })
    },
    getFilters(data) {
        // 获取过滤条件数据
        // this.filterOptions = data
        this.filterOptions = Object.assign({}, this.filterOptions, data)
        this.page.pageIndex = 1
        this.getList()
    },
    generateSearchs(data) {
      // 整理搜索框数据并传递
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }

      this.$refs.globalFilter1.getData(filterData);
      // this.postSearch(filterData)
    },
    getSearch(d) {
      // 接收搜索框数据
      d.keyword = d.key_words
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    goItv(l) {
      if (l.relate_type != 0) return

      this.$router.push({
        path: '/interviewDetail',
        query: {
          r: l.relate_id
        }
      })
    },
    changeClasses(s) {
      // 切换分类，分类和类型联动，默认选择类型第一项, 如果有已选项则选已选项
      this.bases.forEach((i) => {
        if (s === i.id) {
          this.classes = i.list
          let selected = null
          this.classes.forEach(c => {
            if (c.selected) {
              selected = c
            }
          })
          selected = selected || this.classes[0]
          this.$set(this.classInfo, 'id', selected.id)
        }
      })
    },
    switchToggle(t) {
      this.toggleOn = t
      this.page.pageIndex = 1
      this.getList()
    },
    getDetail() {
      // 获取详情数据
      const id = this.$route.query.d
      const info = {
        id: id
      }

      common.myFetch(apis.Expand_detail, info)
      .then((data) => {
        this.matchData(data.detail)
        // this.generateSearchs(data.params.top_search.option.list)
      })
    },
    matchData(data) {
      // 匹配数据到页面
      this.username = data.user_name
      this.statusname = data.status_name
      this.statusNum = data.status
      this.title = data.title
      this.name = data.idstring
      this.brand = data.brand
      this.device_model = data.device_model
      this.serial_num = data.serial_num
      this.datePicker = data.buy_time
      this.keeper = data.keeper
      this.location = data.location
      this.seller = data.price_unit
      this.other_comment = data.other_comment
      this.remark = data.remark
      this.bases = data.class_list || []
      this.classes = data.typeArr || []
      this.classInfo.id = data.type_id
      this.user_id = data.user_id
      // this.gps = {
      //   name: data.gps.device_name,
      //   locate: data.gps.address,
      //   point: data.gps.location,
      //   time: data.gps.time
      // }
      this.bases.forEach(i => {
        if (i.selected) {
          this.$set(this.baseInfo, 'id', i.id)
        }
      })
    },
    getList() {
      // 获取关联列表
      const type = this.toggleOn.id
      if (type === 1) {
        this.getExpanduse()
      } else if (type === 2) {
        this.getRecords()
      } else if (type === 3) {
        this.getError()
      } else if (type === 4) {
        this.getStartLog()
      }
    },
    getStartLog() {
      const id = this.$route.query.d
      // this.page.pageIndex = 1;
      let info = {
        device_id: id,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(apis.Start_log, info)
      .then((data) => {
        console.log(data)
        this.days = data.days
        this.startLog = data.list
        this.$set(this.page, "total", data.page.row_count - 0);
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
      })
    },
    getExpanduse() {
      const id = this.$route.query.d
      let info = {
        id: id,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      info = Object.assign({}, this.filterOptions, info, this.searchOptions)

      common.myFetch(apis.Expanduse, info)
      .then((data) => {
        console.log(data)
        this.days = data.days
        this.tasks = data.list
        this.generateSearchs(data.params.top_search.option.list)
        // console.log(common.calculatePage(data.page.row_count - 0, this.page.pageSize))
        this.$set(this.page, "total", data.page.row_count - 0);
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
      })
    },
    getError() {
      const id = this.$route.query.d
      // this.page.pageIndex = 1;
      let info = {
        device_id: id,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(apis.Bug_list, info)
      .then((data) => {
        console.log(data)
        this.days = data.days
        this.errList = data.list
        this.$set(this.page, "total", data.page.row_count - 0);
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
      })
    },
    getRecords() {
      // 获取出返记录
      const id = this.$route.query.d
      const info = {
        device_id: id,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(apis.Res_device_records, info)
      .then((data) => {
        this.records = data.list
        this.$set(this.page, "total", data.page.row_count - 0);
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
      })
    },
    getTasks() {
      // 获取相关任务
      const id = this.$route.query.d
      const info = {
        device_id: id,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(apis.Res_device_uses, info)
      .then((data) => {
        this.tasks = data.list
        this.$set(this.page, "total", data.page.row_count - 0);
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
      })
    },
    cancelTask(id) {
      // 取消任务
      const info = {
        task_id: id
      }

      common.myFetch(apis.Res_device_task_cancel, info)
      .then((data) => {
        this.$toast(data)
      })
    },
    endTask(id) {
      // 结束任务
      this.$refs.stopUse.open(id)
    },
    async delDevice() {
      // 删除设备
      const c = await this.$confirm('确认删除吗？')
      if (!c) return
      const id = this.$route.query.d
      const info = {
        device_id: id,
        status: -1
      }

      common.myFetch(apis.Res_device_use, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
          window.close()
        }
      })
    },
    stopUse() {
      // 停用设备
      this.$Dialog({
        title: '停用备注',
        placeholder: '请输入启用情况',
        errTitle: '无需输入',
        canEdit: true,
        singleBtn: true,
        maxLength: 20
      }).then(res => {
        if(res) {
          console.log(res)
          let remark = ''
          if(res != 'null'){
            remark = res
          }

          const info = {
            device_id: this.$route.query.d,
            status: 0,
            remark: remark
          }

          common.myFetch(apis.Res_device_use, info)
          .then((data) => {
            if (data) {
              this.$toast(data)
              this.getDetail()
              this.page.pageIndex = 1
              this.getList()
            }
          })
        }
      })
    },
    startUse() {
      // 停用设备
      this.$Dialog({
        title: '启用备注',
        placeholder: '请输入启用情况',
        errTitle: '无需输入',
        canEdit: true,
        singleBtn: true,
        maxLength: 20
      }).then(res => {
        if(res) {
          console.log(res)
          let remark = ''
          if(res != 'null'){
            remark = res
          }

          const info = {
            device_id: this.$route.query.d,
            status: 1,
            remark: remark
          }

          common.myFetch(apis.Res_device_use, info)
          .then((data) => {
            if (data) {
              this.$toast(data)
              this.getDetail()
              this.page.pageIndex = 1
              this.getList()
            }
          })
        }
      })
    },
    saveDevice() {
      // 保存设备
      const device_id = this.$route.query.d
      const class_id = this.baseInfo.id
      const class_title = this.bases.map(i => {return i.id === class_id ? i.title : ''}).join('')
      const type_id = this.classInfo.id
      const type_title = this.classes.map(i => {return i.id === type_id ? i.title : ''}).join('')
      const title = this.title
      const location = this.locate
      const price_unit = this.seller
      const price = this.price

      const info = {
        id: this.$route.query.d,
        title: title,
        idstring: this.name,
        type_id: type_id,
        brand: this.brand,
        device_model: this.device_model,
        serial_num: this.serial_num,
        buy_time: this.datePicker,
        keeper: this.keeper,
        location: this.location,
        other_comment: this.other_comment,
        remark: this.remark
      }

      common.myFetch(apis.Edit_expand, info)
      .then((data) => {
        this.$toast(data)
      })
    },
    exportRecords() {
      // 导出出返库记录
      const id = this.$route.query.d
      const info = {
        device_id: id,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        page_type: 'download'
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys)
      const url = apis.Res_device_records
      // const url = apis.Res_device_records + common.obj2Str(params)

      // window.open(url)
      common.exportRes(url, params)
    }
  },
  mounted() {
    // this.switchToggle(this.toggles[0])
    this.getDetail()
    this.switchToggle(this.toggles[0])
    // this.$ResourcesDetail(1)
  }
}
</script>

<style lang="less" src="@assets/css/resource/extraEquipmentDetail.less" scoped>
</style>

<style lang="less">
.extraEquipmentDetail {
    .date {
      padding: 0 !important;
    }

    .el-date-editor {
      width: 100%;
      height: 100%;

      .el-icon-date {
        line-height: 28px;
      }

      .el-input__icon {
        line-height: 28px;
      }

      input {
        width: 100%;
        height: 100%;
        border: none;
        background: transparent;
      }
    }
}
</style>